import '@/installCompositionApi.js'
import Vue from 'vue'
import App from '@/App.vue'
import Notifications from 'vue-notification'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import translate from '@/plugins/translate'
import notify from '@/plugins/notify'
import '@/assets/css/helper-classes.css';
// import LogRocket from 'logrocket';
// LogRocket.init('rp7yli/webbooking');

Vue.use(translate)
Vue.config.productionTip = false
Vue.use(Notifications)
Vue.use(notify)

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
